/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { PlanState } from 'src/app/services/plan-state.service';
import { dateCache } from '@touchplan/common';
import { LaborCount } from 'src/app/app-data/models/LaborCount';

export class CrewSizeQuery {
	public data: Map<string, LaborCount>;
	constructor() {}

	public setData(data: Map<string, LaborCount>) {
		this.data = data;
	}

	public getRange(
		start: string,
		end: string,
		inclusive: '()' | '[)' | '(]' | '[]' = '()'
	): Map<string, LaborCount> {
		const result = new Map();
		if (!this.data) {
			return result;
		}
		this.data.forEach((labor, key) => {
			if (dateCache.isBetween(key, start, end, inclusive)) {
				result.set(key, labor);
			}
		});
		return result;
	}

	public getDay(day: string): LaborCount {
		if (!this.data) {
			return null;
		}
		return this.data.get(day);
	}

	public destroy(): void {
		this.data.clear();
		this.data = null;
	}
}
